import React from "react"

import { useIntl } from "react-intl"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ExchangeNavigation from "../components/exchange_navigation"
import ExchangeSell from "../components/exchange_sell"

const ExchangeSellPage = ({ location }) => {
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: "Sell" })
  return (
    <Layout pageTitle={pageTitle} location={location}>
      <SEO title={pageTitle} />
      <ExchangeNavigation location={location} />
      <ExchangeSell />
    </Layout>
  )
}

export default ExchangeSellPage
